import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class ParameterService {
  constructor(private route: ActivatedRoute) {}

  getInitialParameters() {
    if (location.href.indexOf('id_token') < 0) {
      const params = this.getParamsFromURL(location.href);

      if (Object.entries(params).length > 0) {
        sessionStorage.setItem('initParams', JSON.stringify(params));
      }
    }
  }

  getParamsFromURL(url) {
    const array = url.match(/\w+=\w+/g);
    const result = {};
    let tmp = [];

    if (array !== null) {
      for (let i = 0; i < array.length; i++) {
        tmp = array[i].split('=');
        result[tmp[0]] = tmp[1];
      }
    }

    return result;
  }
}
